export const education = [
  {
    name: " U. Cooperativa de Colombia",
    altText: "University UCC logo",
    logo: "UCC.png",
    period: "(2014-2019)",
    title: "Systems engineer",
    type: "career",
  },

  {
    name: " U. Nacional Autónoma de México ",
    altText: "University UNAM logo",
    logo: "UNAM-universidad.png",
    period: "(2017-2017)",
    title: "Computer engineering, exchange semester",
    type: "career",
  },

  {
    name: " Centro Colombiano de Estudios Profesionales",
    altText: "Centro Colombiano de Estudios Profesionales logo",
    logo: "cecep.svg",
    period: "(2010-2013)",
    title: "Systems technology",
    type: "career",
  },
  {
    name: "Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2023)",
    title: "Testing React with Jest and React Testing Library",
    type: "certification",
    urlCertificate: "JestAndTestLibrary.jpg",
  },
  {
    name: " Coursera",
    altText: "coursera it logo",
    logo: "coursera.png",
    period: "(2023)",
    title: "Advanced React",
    type: "certification",
    urlCertificate: "coursera.png",
  },
  {
    name: " Moove it",
    altText: "Moove it logo",
    logo: "mooveIt.png",
    period: "(2022)",
    title: "Participation in the Bootcamp promoted by MooveIt",
    type: "certification",
    urlCertificate: "mooveIt.png",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2021-2022)",
    title: "The Complete JavaScript Course 2022: From Zero to Expert!",
    type: "certification",
    urlCertificate: "TheCompleteJavaScriptCourse2023-FromZerotoExpert.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "React- The Complete Guide (Incl Hooks, React Router, Redux)",
    type: "certification",
    urlCertificate: "ReactTheCompleteGuide.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "Build Responsive Real-World Websites with HTML and CSS",
    type: "certification",
    urlCertificate: "BuildResponsiveReal-WorldWebsitesWithHTMLandCSS.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "Advanced CSS and Sass: Flexbox, Grid, Animations and More!",
    type: "certification",
    urlCertificate: "AdvancedCSSandSassFlexboxGridAnimationsandMore!.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "The Complete jQuery Course: From Beginner To Advanced!",
    type: "certification",
    urlCertificate: "TheCompletejQueryCourse.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "Principios Solid y Cleand code",
    type: "certification",
    urlCertificate: "PrincipiosSOLIDyCleanCode.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "Learn JIRA with real-world examples(+Confluence bonus)",
    type: "certification",
    urlCertificate: "LearnJIRAwithReal-worldExamplesConfluenceBonus.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2022)",
    title: "Mastering TypeScript-2022 Edition",
    type: "certification",
    urlCertificate: "MasteringTypeScript2023Edition.jpg",
  },

  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2023)",
    title: " Asp.Net Core : The Complete Guide To Build RESTful Api's",
    type: "certification",
    urlCertificate: "Asp.NetCore-TheCompleteGuideToBuildRestfulApis.jpg",
  },
  {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2023)",
    title: "React Query / TanSack Query: React Server State Management",
    type: "certification",
    urlCertificate: "ReactQuery.jpg",
  },
   {
    name: " Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2023)",
    title: "Docker for the Absolute Beginner - Hands On - DevOps",
    type: "certification",
    urlCertificate: "Docker.jpg",
  },
  {
    name: "Intermediate Level in Talking English Course",
    altText: "Intermediate Level in Talking English Course logo",
    logo: "noLogo.png",
    period: "(2023)",
    title: "Intermediate Level in Talking English Course",
    type: "certification",
    urlCertificate: "IntermediateEnglish.jpg",
  },
  {
    name: "Udemy - Virtual course",
    altText: "Udemy logo",
    logo: "Udemy.png",
    period: "(2025)",
    title: "Microfrontends with React: A complete Developer's Guide",
    type: "certification",
    urlCertificate: "MicrofrontendsWithReact.jpg",
  },
];
